import { Component } from '@angular/core';

@Component({
  selector: 'app-fbdocumentation',
  templateUrl: './fbdocumentation.component.html',
  styleUrls: ['./fbdocumentation.component.css']
})
export class FbdocumentationComponent {

}
